import React from 'react';
import { createPortal } from 'react-dom';
import Card from '../../../../../shared/components/Card';
import { UserWithRole, RoleHistory } from '../../../../../shared/services/userService';
import usePageTranslation from '../../../../../shared/hooks/usePageTranslation';

interface RoleHistoryModalProps {
  user: UserWithRole;
  history: RoleHistory[];
  onClose: () => void;
}

const RoleHistoryModal: React.FC<RoleHistoryModalProps> = ({
  user,
  history,
  onClose
}) => {
  const { t } = usePageTranslation('panel', 'UserRolesManagement');

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <Card className="max-w-2xl w-full p-6 max-h-[80vh] overflow-y-auto">
        <h3 className="text-2xl font-bold text-white mb-4">
          {t('modal.history.title')} - {user.username}
        </h3>
        {history.length === 0 ? (
          <p className="text-gray-400">{t('modal.history.noHistory')}</p>
        ) : (
          <div className="space-y-3">
            {history.map((item) => (
              <div
                key={item.id}
                className="p-4 bg-gray-800/50 rounded-lg border border-gray-700"
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="text-white font-semibold">
                    {item.old_role_name} → {item.new_role_name}
                  </span>
                  <span className="text-gray-400 text-sm">
                    {new Date(item.created_at).toLocaleString('fr-FR')}
                  </span>
                </div>
                {item.reason && (
                  <p className="text-gray-400 text-sm mb-1">{item.reason}</p>
                )}
                <p className="text-gray-500 text-xs">
                  {t('modal.history.changedBy')} {item.changed_by_username}
                </p>
              </div>
            ))}
          </div>
        )}
        <button
          onClick={onClose}
          className="mt-6 w-full px-4 py-3 bg-gray-700 text-white rounded-lg font-semibold hover:bg-gray-600 transition-colors"
        >
          {t('modal.history.close')}
        </button>
      </Card>
    </div>,
    document.body
  );
};

export default RoleHistoryModal;

